import "antd/dist/reset.css";

import GrowthBookRootProvider from "./src/components/GrowthBookRootProvider";
import { MixpanelProvider } from "./src/tracking";
import React from "react";

export const wrapRootElement = ({ element }) => (
	<MixpanelProvider>
		<GrowthBookRootProvider>{element}</GrowthBookRootProvider>
	</MixpanelProvider>
);
